import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "sign-box" }
const _hoisted_2 = { class: "sign-state" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "reason"
}
const _hoisted_5 = {
  key: 0,
  style: {"font-style":"12px","color":"#333"}
}
const _hoisted_6 = { style: {"overflow-wrap":"anywhere"} }
const _hoisted_7 = { class: "sign-form" }
const _hoisted_8 = {
  key: 1,
  class: "btn-wrap"
}
const _hoisted_9 = { class: "btn-wrap" }
const _hoisted_10 = {
  key: 1,
  class: "btn-wrap"
}
const _hoisted_11 = {
  key: 2,
  class: "btn-wrap"
}
const _hoisted_12 = {
  key: 3,
  class: "btn-wrap"
}
const _hoisted_13 = {
  key: 4,
  class: "centerErrMsg"
}
const _hoisted_14 = {
  key: 5,
  class: "btn-wrap"
}
const _hoisted_15 = {
  key: 6,
  class: "btn-wrap"
}
const _hoisted_16 = {
  key: 7,
  class: "btn-wrap"
}
const _hoisted_17 = {
  key: 8,
  class: "centerErrMsg"
}
const _hoisted_18 = {
  key: 9,
  class: "btn-wrap"
}
const _hoisted_19 = {
  key: 10,
  class: "btn-wrap"
}
const _hoisted_20 = {
  key: 11,
  class: "btn-wrap"
}
const _hoisted_21 = {
  key: 0,
  class: "sign-link"
}
const _hoisted_22 = { class: "flex_c" }
const _hoisted_23 = { class: "departmentlink_btnView" }
const _hoisted_24 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_25 = {
  key: 1,
  style: {"text-align":"center"}
}
const _hoisted_26 = {
  key: 2,
  style: {"text-align":"center"}
}
const _hoisted_27 = { style: {"display":"flex","justify-content":"center","margin-top":"10px"} }
const _hoisted_28 = { style: {"display":"flex","justify-content":"center","margin-top":"10px"} }
const _hoisted_29 = { style: {"display":"flex","justify-content":"center","margin-top":"10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_dformVue = _resolveComponent("dformVue")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_dProcess = _resolveComponent("dProcess")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_steps, {
      active: _ctx.step,
      "align-center": "",
      style: {"margin-top":"10px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_step, { title: "生源信息" }),
        _createVNode(_component_el_step, { title: "签约信息" })
      ]),
      _: 1
    }, 8, ["active"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.stateImageUrl)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "state-img",
              src: _ctx.stateImageUrl
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        (_ctx.agreementState == 5 || _ctx.requestState.agreement_state == 6)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[28] || (_cache[28] = _createElementVNode("p", { style: {"color":"#ff0000"} }, [
                _createElementVNode("span", null, "未通过原因: ")
              ], -1)),
              (_ctx.signMode == 1 && _ctx.requestState.stateby == 'department')
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, " 请自行与用人单位沟通拒绝原因。"))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.requestState.remark), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("div", null, [
          (_ctx.showTalent)
            ? (_openBlock(), _createBlock(_component_dformVue, {
                key: 0,
                formconfig: _ctx.schema,
                data: _ctx.dataTalent
              }, null, 8, ["formconfig", "data"]))
            : _createCommentVNode("", true),
          (_ctx.showTalent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nextPage()))
                }, {
                  default: _withCtx(() => _cache[29] || (_cache[29] = [
                    _createTextVNode("下一页")
                  ])),
                  _: 1,
                  __: [29]
                })
              ]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, _ctx.step == 0]
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createVNode(_component_dformVue, {
            class: "step2",
            formconfig: _ctx.signForm,
            data: _ctx.dataSign
          }, null, 8, ["formconfig", "data"]),
          (_ctx.requestStateData.request_state_list?.length)
            ? (_openBlock(), _createBlock(_component_dProcess, {
                key: 0,
                data: _ctx.requestStateData
              }, null, 8, ["data"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            ((_ctx.agreementState == 3 && _ctx.employment_Type == '01' && (_ctx.signMode == 2 || _ctx.signMode == 1)))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadXieYi()))
                }, {
                  default: _withCtx(() => _cache[30] || (_cache[30] = [
                    _createTextVNode("协议书下载")
                  ])),
                  _: 1,
                  __: [30]
                }))
              : _createCommentVNode("", true),
            ((_ctx.notosign && (_ctx.agreementState == -1 || _ctx.agreementState == 0) && _ctx.employment_Type == '01' && _ctx.signMode == 2 && _ctx.currentState != 6))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "primary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.makeXieYi()))
                }, {
                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                    _createTextVNode("生成协议书并下载")
                  ])),
                  _: 1,
                  __: [31]
                }))
              : _createCommentVNode("", true)
          ]),
          (_ctx.notosign && _ctx.agreementState == 2 && _ctx.employment_Type != '01' && _ctx.employment_Type != '02')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ((_ctx.talentClearAuditModel = true)))
                }, {
                  default: _withCtx(() => _cache[32] || (_cache[32] = [
                    _createTextVNode("撤回审核")
                  ])),
                  _: 1,
                  __: [32]
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.notosign && _ctx.recordid && _ctx.agreementState == 0 && _ctx.employment_Type == '01' && _ctx.signMode == 2 && _ctx.currentState != 6 && (_ctx.revokeSignState == -1 || _ctx.revokeSignState == 0) && _ctx.canRevoke)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => ((_ctx.talentClearAuditModel = true)))
                }, {
                  default: _withCtx(() => _cache[33] || (_cache[33] = [
                    _createTextVNode("撤回签约")
                  ])),
                  _: 1,
                  __: [33]
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.recordid && _ctx.agreementState == 0 && _ctx.employment_Type == '01' && _ctx.signMode == 2 && _ctx.revokeSignState == 1 && _ctx.canRevoke)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_el_button, {
                  disabled: "",
                  type: "primary"
                }, {
                  default: _withCtx(() => _cache[34] || (_cache[34] = [
                    _createTextVNode("撤回中...")
                  ])),
                  _: 1,
                  __: [34]
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.recordid && _ctx.agreementState == 0 && _ctx.employment_Type == '01' && _ctx.signMode == 2 && _ctx.revokeSignState == 3 && _ctx.revokeSignAuditReason)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, "未通过原因：" + _toDisplayString(_ctx.revokeSignAuditReason), 1))
            : _createCommentVNode("", true),
          (_ctx.notosign && _ctx.recordid && _ctx.agreementState == 0 && _ctx.employment_Type == '01' && _ctx.signMode == 2 && _ctx.revokeSignState == 3 && _ctx.canRevoke)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ((_ctx.talentClearAuditModel = true)))
                }, {
                  default: _withCtx(() => _cache[35] || (_cache[35] = [
                    _createTextVNode("撤回失败，重新申请")
                  ])),
                  _: 1,
                  __: [35]
                })
              ]))
            : _createCommentVNode("", true),
          ((_ctx.notosign && _ctx.agreementState == 3 && _ctx.allowCancelSign && (_ctx.rescindSignState == -1 || _ctx.rescindSignState == 0)))
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => ((_ctx.talentClearAuditModel = true)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.signMode == 0 && _ctx.employment_Type !=
    '01' && _ctx.employment_Type != '02' ? '撤回签约' : '解除签约'), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          ((_ctx.agreementState == 3 && _ctx.allowCancelSign && _ctx.rescindSignState == 1))
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_el_button, {
                  disabled: "",
                  type: "primary"
                }, {
                  default: _withCtx(() => _cache[36] || (_cache[36] = [
                    _createTextVNode("解约中...")
                  ])),
                  _: 1,
                  __: [36]
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.agreementState == 3 && _ctx.rescindSignState == 3 && _ctx.rescindSignAuditReason)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, "解约未通过原因：" + _toDisplayString(_ctx.rescindSignAuditReason), 1))
            : _createCommentVNode("", true),
          ((_ctx.notosign && _ctx.agreementState == 3 && _ctx.allowCancelSign && _ctx.rescindSignState == 3))
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => ((_ctx.talentClearAuditModel = true)))
                }, {
                  default: _withCtx(() => _cache[37] || (_cache[37] = [
                    _createTextVNode("解约失败，重新申请")
                  ])),
                  _: 1,
                  __: [37]
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.showOnlineBtn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.prevPage()))
                }, {
                  default: _withCtx(() => _cache[38] || (_cache[38] = [
                    _createTextVNode("上一页")
                  ])),
                  _: 1,
                  __: [38]
                }),
                (_ctx.notosign && _ctx.agreementState == 1)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openTelentConfirmModel()))
                    }, {
                      default: _withCtx(() => _cache[39] || (_cache[39] = [
                        _createTextVNode("确认签约")
                      ])),
                      _: 1,
                      __: [39]
                    }))
                  : _createCommentVNode("", true),
                (_ctx.notosign && _ctx.agreementState == 1)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "primary",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.talentRefuseSignModel = true))
                    }, {
                      default: _withCtx(() => _cache[40] || (_cache[40] = [
                        _createTextVNode("拒绝签约")
                      ])),
                      _: 1,
                      __: [40]
                    }))
                  : _createCommentVNode("", true),
                (_ctx.notosign && _ctx.agreementState == 6)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 2,
                      type: "primary",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.submit()))
                    }, {
                      default: _withCtx(() => _cache[41] || (_cache[41] = [
                        _createTextVNode("重新提交")
                      ])),
                      _: 1,
                      __: [41]
                    }))
                  : _createCommentVNode("", true),
                (_ctx.notosign && _ctx.agreementState == 2 && _ctx.requestState.stateby != 'faculty' && _ctx.signMode == 0 && (_ctx.employment_Type == '01' || _ctx.employment_Type == '02'))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 3,
                      type: "primary",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.submit()))
                    }, {
                      default: _withCtx(() => _cache[42] || (_cache[42] = [
                        _createTextVNode("重新提交")
                      ])),
                      _: 1,
                      __: [42]
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.showOnlineBtn && _ctx.currentState != 6)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.prevPage()))
                }, {
                  default: _withCtx(() => _cache[43] || (_cache[43] = [
                    _createTextVNode("上一页")
                  ])),
                  _: 1,
                  __: [43]
                }),
                (_ctx.agreementState == -1 && _ctx.signMode == 2)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.save()))
                    }, {
                      default: _withCtx(() => _cache[44] || (_cache[44] = [
                        _createTextVNode("保存")
                      ])),
                      _: 1,
                      __: [44]
                    }))
                  : _createCommentVNode("", true),
                ((_ctx.notosign && _ctx.agreementState == -1 || _ctx.agreementState == 1 || _ctx.agreementState == 0) && _ctx.revokeSignState != 1)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "primary",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.submit()))
                    }, {
                      default: _withCtx(() => _cache[45] || (_cache[45] = [
                        _createTextVNode("提交")
                      ])),
                      _: 1,
                      __: [45]
                    }))
                  : _createCommentVNode("", true),
                (_ctx.notosign && _ctx.agreementState == 2 && _ctx.requestState.stateby != 'faculty' && _ctx.signMode == 0 && (_ctx.employment_Type == '01' || _ctx.employment_Type == '02'))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 2,
                      type: "primary",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.submit()))
                    }, {
                      default: _withCtx(() => _cache[46] || (_cache[46] = [
                        _createTextVNode("重新提交")
                      ])),
                      _: 1,
                      __: [46]
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, _ctx.step == 1]
        ])
      ]),
      _cache[47] || (_cache[47] = _createElementVNode("div", { class: "sign-reminder" }, null, -1))
    ]),
    (_ctx.showSignLink)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _cache[50] || (_cache[50] = _createElementVNode("span", null, "已生成企业签约链接，将链接发送给企业HR，其填写完成后即可确认签约信息：", -1)),
          _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.departmentUrl + _ctx.signSuNumber), 1),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.copySignLink()))
            }, {
              default: _withCtx(() => _cache[48] || (_cache[48] = [
                _createTextVNode("复制链接")
              ])),
              _: 1,
              __: [48]
            }),
            (_ctx.agreementState != 7)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "info",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.invalidLinkModel = true))
                }, {
                  default: _withCtx(() => _cache[49] || (_cache[49] = [
                    _createTextVNode(" 作废链接 ")
                  ])),
                  _: 1,
                  __: [49]
                }))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.talentClearAuditModel,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.talentClearAuditModel) = $event)),
      width: _ctx.signModePopupWidth,
      center: ""
    }, {
      default: _withCtx(() => [
        ((_ctx.agreementState == 2))
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, "确定要撤回当前审核吗？"))
          : _createCommentVNode("", true),
        ((_ctx.agreementState == 3))
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, "确定要" + _toDisplayString(_ctx.signMode == 0 && _ctx.employment_Type !=
    '01' && _ctx.employment_Type != '02' ? '撤回' : '解除') + "当前签约吗？", 1))
          : _createCommentVNode("", true),
        ((_ctx.agreementState == 0))
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, "确定要撤回当前签约吗？"))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_el_button, {
            type: "info",
            onClick: _cache[19] || (_cache[19] = ($event: any) => ((_ctx.talentClearAuditModel = false)))
          }, {
            default: _withCtx(() => _cache[51] || (_cache[51] = [
              _createTextVNode("否")
            ])),
            _: 1,
            __: [51]
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[20] || (_cache[20] = ($event: any) => {_ctx.talentClearAuditModel = false; _ctx.rescind()})
          }, {
            default: _withCtx(() => _cache[52] || (_cache[52] = [
              _createTextVNode("是")
            ])),
            _: 1,
            __: [52]
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "width"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.talentRefuseSignModel,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.talentRefuseSignModel) = $event)),
      width: _ctx.signModePopupWidth,
      center: "",
      title: "拒绝签约"
    }, {
      default: _withCtx(() => [
        _cache[55] || (_cache[55] = _createElementVNode("div", { style: {"padding-bottom":"10px"} }, [
          _createElementVNode("span", { style: {"color":"red"} }, "温馨提示* "),
          _createTextVNode("拒绝签约后，企业信息将作废， 可自行修改个人信息，重新生成 新签约链接")
        ], -1)),
        _createVNode(_component_el_input, {
          modelValue: _ctx.talentRefuseSignCause,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.talentRefuseSignCause) = $event)),
          placeholder: "请输入拒绝原因",
          autosize: { minRows: 2, maxRows: 4 },
          type: "textarea"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_el_button, {
            type: "info",
            onClick: _cache[23] || (_cache[23] = ($event: any) => ((_ctx.talentRefuseSignModel = false)))
          }, {
            default: _withCtx(() => _cache[53] || (_cache[53] = [
              _createTextVNode("取消")
            ])),
            _: 1,
            __: [53]
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            disabled: !_ctx.talentRefuseSignCause,
            onClick: _cache[24] || (_cache[24] = ($event: any) => {_ctx.talentRefuseSignModel = false; _ctx.refuseSign(_ctx.talentRefuseSignCause)})
          }, {
            default: _withCtx(() => _cache[54] || (_cache[54] = [
              _createTextVNode("确定")
            ])),
            _: 1,
            __: [54]
          }, 8, ["disabled"])
        ])
      ]),
      _: 1,
      __: [55]
    }, 8, ["modelValue", "width"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.invalidLinkModel,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.invalidLinkModel) = $event)),
      width: _ctx.signModePopupWidth,
      center: "",
      title: "拒绝签约"
    }, {
      default: _withCtx(() => [
        _cache[57] || (_cache[57] = _createElementVNode("div", { style: {"padding-bottom":"10px"} }, "作废链接后，企业无法再继续签约，可自行修改个人信息。重新生成新签约链接", -1)),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[26] || (_cache[26] = ($event: any) => {_ctx.invalidLinkModel = false; _ctx.refuseSign('人才作废链接')})
          }, {
            default: _withCtx(() => _cache[56] || (_cache[56] = [
              _createTextVNode("确定")
            ])),
            _: 1,
            __: [56]
          })
        ])
      ]),
      _: 1,
      __: [57]
    }, 8, ["modelValue", "width"])
  ], 64))
}